import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { AccessTime as ClockIcon } from '@mui/icons-material';

export const DateTime: React.FC = () => {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  return (
    <Box 
      component="div"
      sx={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: 1,
        color: 'text.secondary',
        minWidth: { xs: 'auto', sm: '250px' },
        justifyContent: 'flex-end',
        userSelect: 'none'
      }}
    >
      <ClockIcon 
        fontSize="small" 
        sx={{ color: 'primary.main' }}
      />
      <Box 
        component="div" 
        sx={{ 
          display: { xs: 'none', sm: 'flex' },
          alignItems: 'center',
          gap: 1,
          typography: 'body2',
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, Roboto, Arial, sans-serif'
        }}
      >
        <Box 
          component="span" 
          sx={{ 
            fontWeight: 500,
            color: 'text.primary'
          }}
        >
          {formatDate(dateTime)}
        </Box>
        <Box 
          component="span" 
          sx={{ 
            fontWeight: 500,
            color: 'primary.main',
            letterSpacing: '0.5px'
          }}
        >
          {formatTime(dateTime)}
        </Box>
      </Box>
    </Box>
  );
};